import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import notFoundHero from '../img/404.png';
import '../App.css';

export default function NotFoundPage() {
  const { t } = useI18n();

  return (
    <main className="not-found-page">
      <div className="not-found-inner">
        <nav className="not-found-breadcrumb svc-breadcrumb-trail" aria-label="Útvonal">
          <Link className="svc-breadcrumb-seg not-found-breadcrumb-home" to="/">
            <span className="not-found-breadcrumb-home-icon" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 10.5 12 3l9 7.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5 10v10h14V10" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
            {t('not_found_home')}
          </Link>
          <span className="svc-breadcrumb-sep" aria-hidden="true">
            /
          </span>
          <span className="svc-breadcrumb-current not-found-breadcrumb-404" aria-current="page">
            404
          </span>
        </nav>

        <div className="not-found-grid">
          <div className="not-found-copy">
            <p className="not-found-code" aria-hidden="true">
              404
            </p>
            <div className="not-found-rule" aria-hidden="true" />
            <h1 className="not-found-title">{t('not_found_title')}</h1>
            <p className="not-found-desc">{t('not_found_desc')}</p>
            <div className="not-found-actions">
              <Link className="not-found-btn not-found-btn--primary" to="/">
                {t('not_found_back')}
              </Link>
              <Link className="not-found-btn not-found-btn--secondary" to="/" state={{ scrollTo: 'kapcsolat' }}>
                {t('nav_contact')}
              </Link>
            </div>
          </div>

          <div className="not-found-visual" aria-hidden="true">
            <div className="not-found-visual-clouds" />
            <img
              className="not-found-hero-img"
              src={notFoundHero}
              alt=""
              width={1448}
              height={1086}
              decoding="async"
            />
          </div>
        </div>
      </div>
    </main>
  );
}
